// extracted by mini-css-extract-plugin
module.exports = {"downloadButton":"styles_downloadButton__2PHrYzpZPFjb681sdAy0JF"};